import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Features from "@/pages/home/components/Features";
import Showcase from "@/pages/home/components/Showcase";
import Scenarios from "@/pages/home/components/Scenarios";
import Guide from "@/pages/home/components/Guide";
import Quality from "@/pages/home/components/Quality";
import AdFree from "@/pages/home/components/AdFree";
import Reviews from "@/pages/home/components/Reviews";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Showcase />
        <Scenarios />
        <Guide />
        <Quality />
        <AdFree />
        <Reviews />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}